import {VNode} from 'snabbdom';

import {Section, SectionItem} from 'common/components/items-menu/types';
import {DashboardOrigin} from 'common/report/util/bookmark-overrides';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {HeaderUserInfo} from 'common/widgets/user-list/types';
import {Dashboard} from 'common/report/dashboards/types';
import {GlobalAccessType} from 'common/widgets/create-entity-modal/types';
import {EntityTypeWithContentSupport} from 'common/report/util/saved-entities';

export const UntitledReportName = `Untitled`;
export const UntitledReportNameKey = `reports.header.title-placeholder`;
export const REPORT_HEADER_HEIGHT = 60;

export enum HeaderAction {
  Delete = `delete`,
  Rename = `rename`,
  Refresh = `refresh`,
  Subscribe = `subscribe`,
  //** This is for legacy modes, like impact */
  Save = `save`,
  SaveNew = `save-new`,
  Duplicate = `duplicate`,
  // TODO: rename
  Load = `open`,
  Reset = `new`,

  CreatedBy = `created-by`,
  Share = `share`,

  // alerts
  CreateAlert = `create-alert`,
  ManageAlert = `manage-alert`,
  EnableAlerts = `enable-alerts`,
  IncreaseAlertLimit = `increase-alerts`,

  QuerySampling = `query-sampling`,
  DismissQuerySamplingTour = `dismiss-query-sampling-tour`,
  Undo = `undo`,
  Redo = `redo`,
}

export type ResultsKeysAndValues = {
  name: string;
  displayName: string;
  values: string[];
  displayValues: string[];
  isPercentage?: boolean;
};

export type HeaderCustomAlertParams =
  | {
      isCustomAlertsActionVisible: true;
      enableCustomAlertConditionTypes?: boolean;
      enableAnomalyDetectionControls?: boolean;
      resultsKeysAndValues: ResultsKeysAndValues[];
      customAlertTimeUnit?: string;
      customAlertsDisabledText?: string;
      customAlertIntervalDays?: number;
      bookmarkParams?: TODO;
    }
  | EmptyObj;

export type QueryReportHeaderParams = {
  autoRefreshIntervalMs?: number | null;
  computedAt?: string;
  controlItems?: Array<SectionItem | {slot: string}>;
  disableHeaderMargin?: boolean;
  displayContext: SearchDisplayContext;
  duplicateReportUrl?: string;
  emptyEntityName?: string;
  entitiesLoading?: boolean;
  entityType: EntityTypeWithContentSupport;
  hasUnsavedChanges: boolean;
  hideActions?: HeaderAction[];
  invalidEntity: boolean;
  invalidMessage: string;
  isPublicDashboard?: boolean;
  isTemplateDashboard?: boolean;
  isTemplateDraftDashboard?: boolean;
  isSaveFailed?: boolean;
  overflowControlItems: Section[];
  onlineUsers?: Array<{id: number; color: string; name: string; email: string}>;
  originDashboard?: DashboardOrigin;
  projectAsOfDate?: string;
  projectId: number;
  selectedBookmarkDashboard?: DashboardOrigin;
  selectedEntityDescription: string;
  selectedEntityId: number | null;
  selectedEntityName: string;
  selectedEntityCreator?: HeaderUserInfo;
  selectedEntityEditor?: HeaderUserInfo;
  isSavingBookmark?: boolean;
  trackName: string;
  userId: number;
  workspaceId: number;
  enableBoardsCopying?: boolean;
  boardsTitleBadgeEl?: VNode;
  dashboardsRoute?: DashboardOrigin[];
  headerActionItemsEl?: VNode;
  homePage?: {
    title: string;
    url: string;
  };

  // permissions
  canWrite: boolean;
  canSave: boolean;
  canShare: boolean;
  isSuperadmin: boolean;
  allowStaffOverride: boolean;

  // sharing-disabled (visibility controls in create-entity-modal)
  visibilityControlsMessage?: string;

  // query sampling
  samplingFactor?: number;
  isQuerySamplingEnabled?: boolean;
  isQuerySamplingActionVisible?: boolean;
  querySamplingDisabledMessage?: string;
  triggerQuerySamplingTourTooltip?: boolean;
} & Partial<HeaderCustomAlertParams>;

export enum SaveModes {
  SaveNew = `save-new`,
  Edit = `edit`,
  Save = `save`,
}

export type QueryReportHeaderSave = {
  name: string;
  description: string;
  saveAsNew: boolean;
  dashboard?: Dashboard;
  didSave?: boolean;
  event?: HeaderAction;
  globalAccessType?: GlobalAccessType;
};
